module.exports = __webpack_public_path__ + "static/media/9DESA32.643a9c74.jpg";